import { TurnstileWidget } from '@kompare/captcha-react';
import { CaptchaState } from 'src/common/hooks/useCreateSoWithCaptcha.hook';
import { i18n } from 'src/common/utils/translate.util';
import { colors } from 'src/theme';
import Flex from '../grid/flex.grid';
import { Text } from '../typography/text.typography';

/**
 * The Turnstile widget plus its copy, rendered above a form's submit button while a
 * challenge is due. Spread the `captcha` object from `useCreateSoWithCaptcha` into it;
 * it renders nothing until the API has asked for a captcha, so regular visitors never
 * load Cloudflare's script.
 */
export const CaptchaChallenge = ({ required, message, widgetProps }: CaptchaState) => {
  if (!required) return null;
  return (
    <Flex vertical gap={8} align="center" style={{ width: '100%', marginTop: 16 }}>
      <TurnstileWidget
        {...widgetProps}
        loadErrorFallback={
          <Text type="small" color={colors.error1}>
            {i18n.t('common.globalError')}
          </Text>
        }
      />
      {/* Neutral colour: a Managed widget is still auto-verifying for 1–2 s while this
          shows, and red would read as a failure. */}
      {message && (
        <Text type="small" color={colors.text1}>
          {message}
        </Text>
      )}
    </Flex>
  );
};
